import { ROUTE_BASE_NAME } from '~/constants'

/**
 * This middleware keeps users in the request-to-book flow matching their
 * `rvz28661SimplifiedRtbFlow` assignment. The variant goes to the simplified
 * flow (`/request-to-book/[alias]`), everyone else to the original one
 * (`/rv-rental/request-to-book/[alias]`).
 */
export default defineNuxtRouteMiddleware((to) => {
  const { getExperimentVariant } = useExperiment()
  const getRouteBaseName = useRouteBaseName()
  const { checkRouteNameStartsWith } = useBaseName()
  const name = getRouteBaseName(to)?.toString() ?? ''

  const isSimplifiedRtbFlow = getExperimentVariant('rvz28661SimplifiedRtbFlow') === 'variant'
  const isOnSimplifiedRtbFlow = checkRouteNameStartsWith(name, ROUTE_BASE_NAME.request_to_book)

  if (isSimplifiedRtbFlow === isOnSimplifiedRtbFlow) {
    return
  }

  const localePath = useLocalePath()

  return navigateTo(localePath({
    name: isSimplifiedRtbFlow
      ? ROUTE_BASE_NAME.request_to_book
      : ROUTE_BASE_NAME.rv_rental_request_to_book_alias,
    params: { alias: to.params.alias as string },
    query: to.query,
  }), {
    replace: true,
  })
})
